import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

interface AnimationConfig {
  direction?: 'left' | 'right' | 'up' | 'down';
  delay?: number;
  duration?: number;
  once?: boolean;
}

export const useSectionAnimation = ({
  direction = 'up',
  delay = 0,
  duration = 0.6,
  once = true
}: AnimationConfig = {}) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: once,
  });

  useEffect(() => {
    if (inView) {
      setHasAnimated(true);
    }
  }, [inView]);

  const getTransform = () => {
    switch (direction) {
      case 'left':
        return 'translateX(-20px)';
      case 'right':
        return 'translateX(20px)';
      case 'up':
        return 'translateY(20px)';
      case 'down':
        return 'translateY(-20px)';
      default:
        return 'translateY(0)';
    }
  };

  const initial = {
    opacity: 0,
    transform: getTransform(),
  };

  const animate = {
    opacity: inView ? 1 : 0,
    transform: inView ? 'translate(0)' : getTransform(),
  };

  const transition = {
    duration,
    delay,
    ease: 'easeOut',
  };

  return {
    ref,
    initial,
    animate,
    transition,
    hasAnimated,
    inView,
  };
};
